import React, { Component } from 'react';
import { arrayOf, node } from 'prop-types';

import styles from './Accordion.scss';
import Tab from './components/Tab';

class Accordion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
      firstRender: true,
    };
  }

  static Tab = Tab;

  render() {
    const children = React.Children.map(this.props.children, (child, index) =>
      React.cloneElement(child, {
        firstRender: this.state.firstRender,
        isActive: this.state.activeIndex === index,
        onActive: () =>
          this.setState({
            activeIndex: index,
            firstRender: false,
          }),
      })
    );

    return <div className={styles.root}> {children} </div>;
  }
}

Accordion.propTypes = {
  children: arrayOf(node),
};

Accordion.defaultProps = {
  children: [],
};

export default Accordion;



// WEBPACK FOOTER //
// ./app/components/Accordion/Accordion.jsx